export default "__VITE_ASSET__3bs5UwWN__"